module.exports = __webpack_public_path__ + "img/met-pagos.5b1636d4.svg";